import React, { useState, useEffect } from "react";
import ".//Banner.css"
import { Weight } from "lucide-react";

const Banner = () => {
  const messages = [
    // "It's almost time for the make-a-thon! 🎉",
    <span>Watch the Livestream <a href="https://youtube.com/@nationalmdm?si=smaA8_SR3S74mXZS" 
      target="_blank" 
      rel="noopener noreferrer"
      style={{ textDecoration: "underline", color: "#ffffffff" }}>Here!</a></span>,
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 3000); // change every 3s
    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <div className="banner">
        {messages[index]}
      </div>
  );
};

export default Banner;
